// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-airport-language-redirect-js": () => import("./../../../src/templates/AirportLanguageRedirect.js" /* webpackChunkName: "component---src-templates-airport-language-redirect-js" */),
  "component---src-templates-airport-login-page-js": () => import("./../../../src/templates/AirportLoginPage.js" /* webpackChunkName: "component---src-templates-airport-login-page-js" */)
}

